import React from 'react'
import Card from './Card'
const MultiLocations = (props) => {

    const locationsGroup = JSON.parse(props.locations_group);


    return (
        <div>
          {locationsGroup.map((location) => (
            <Card 
              key={location.id}
              description={location.title}
              message={location.subTitle}
              icon={location.icon}
              map_address={location.address}
              action={{type: "locationLink"}}
            />
          ))}
        </div>
      );
    };

export default MultiLocations